import {EnvironmentInjector, inject, Injectable, runInInjectionContext} from '@angular/core';
import {Router, RoutesRecognized} from "@angular/router";
import {filter, take} from "rxjs";
// TODO: wtf is this import from environment.development?
import {environment} from "../../../environments/environment.development";


interface PreviewDocument {
  path: string;
  guid: string;
}

@Injectable({
  providedIn: 'root'
})
export class PreviewService {
  injector = inject(EnvironmentInjector);
  previewDoc!: PreviewDocument;

  public initPreview() {
    runInInjectionContext(this.injector, () => {
      const router = inject(Router);
      router.events.pipe(
        filter((e) => e instanceof RoutesRecognized),
        take(1)
      ).subscribe((route: any) => {
        let previewGuid = route?.state?.root?.queryParams?.[environment.previewKey];
        if (previewGuid) {
          sessionStorage.setItem(environment.previewKey, previewGuid)
        }
        let documentGuid = route?.state?.root?.queryParams?.['DocumentGuid'];
        this.previewDoc = {guid: documentGuid, path: route.url.split('?')[0]};
      });
    });
  }

  public getPreviewId() {
    return sessionStorage.getItem(environment.previewKey);
  }

  public getDocumentGuid(url: string) {
    return url.includes(this.previewDoc?.path) ?
     this.previewDoc.guid : "";
  }
}
